export default function buttonWidget(editor) {
  editor.DomComponents.addType('eb-button', {
    extend: 'link',
    isComponent(el) {
      return el.getAttribute && el.getAttribute('data-gjs-type') === 'eb-button'
    },
    model: {
      defaults: {
        name: 'Button',
        tagName: 'a',
        editable: true,
        droppable: false,
        content: 'Click Here',
        attributes: {
          'data-gjs-type': 'eb-button',
          href: '#',
        },
        style: {
          'display': 'inline-block',
          'padding': '12px 30px',
          'background-color': '#667eea',
          'color': '#ffffff',
          'text-decoration': 'none',
          'border-radius': '6px',
          'font-size': '16px',
          'font-weight': '600',
          'text-align': 'center',
          'cursor': 'pointer',
          'border': 'none',
          'transition': 'background-color 0.3s ease',
        },
        traits: [
          { type: 'text', name: 'href', label: 'Link URL' },
          { type: 'text', name: 'title', label: 'Title' },
          {
            type: 'select', name: 'target', label: 'Open In',
            options: [
              { id: '_self', label: 'Same Window' },
              { id: '_blank', label: 'New Window' },
            ],
          },
          { type: 'text', name: 'id', label: 'CSS ID' },
        ],
      },
    },
  })

  editor.BlockManager.add('eb-button', {
    label: 'Button',
    category: 'Basic',
    media: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20M4,6V18H20V6H4M6.5,13.5H17.5V10.5H6.5V13.5Z"/></svg>',
    content: { type: 'eb-button' },
  })
}
